"use client";

import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import WhatsAppFormModal from "./WhatsAppFormModal";

const IFRAME_SRC = "/yaris-cross-360/index.htm";

const Viewer360Mobile: React.FC = () => {
	const [formOpen, setFormOpen] = useState(false);

	return (
		<>
			<div
				className="fixed inset-0 w-full border-0 overflow-hidden
					h-[100dvh] min-h-[100vh]
					pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)]
					pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]"
			>
				<iframe
					src={IFRAME_SRC}
					className="absolute inset-0 w-full h-full border-0"
					title="Tour Virtual 360º Yaris Cross"
				/>
			</div>
			<div
				className="fixed z-[9999]
					left-[max(0.75rem,env(safe-area-inset-left))] right-[max(0.75rem,env(safe-area-inset-right))]
					bottom-[max(0.75rem,env(safe-area-inset-bottom))]"
			>
				<button
					type="button"
					onClick={() => setFormOpen(true)}
					className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] active:bg-[#1DA851] text-white font-normal text-xs sm:text-sm uppercase tracking-wide py-3.5 px-3 sm:py-4 sm:px-4 rounded-xl shadow-lg transition-colors w-full min-h-[48px]"
				>
					<span className="text-center leading-tight">FALE COM NOSSOS CONSULTORES</span>
					<FaWhatsapp className="w-5 h-5 flex-shrink-0" aria-hidden />
				</button>
			</div>
			<WhatsAppFormModal isOpen={formOpen} onClose={() => setFormOpen(false)} />
		</>
	);
};

export default React.memo(Viewer360Mobile);
